import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const TeamPitchingChart = ({ leaderboards }) => {
  const { eraData, kData, svData } = useMemo(() => {
    const leaders = leaderboards?.pitching?.leagueLeaders || [];
    const getLeaders = (cat) => leaders.find(l => l.leaderCategory === cat)?.leaders?.slice(0, 8) || [];

    const eraLeaders = getLeaders('era');
    const kLeaders = getLeaders('strikeouts');
    const svLeaders = getLeaders('saves');

    return {
      eraData: { names: eraLeaders.map(l => l.person?.fullName?.split(' ').pop() || '--'), vals: eraLeaders.map(l => Number(l.value) || 0) },
      kData: { names: kLeaders.map(l => l.person?.fullName?.split(' ').pop() || '--'), vals: kLeaders.map(l => Number(l.value) || 0) },
      svData: { names: svLeaders.map(l => l.person?.fullName?.split(' ').pop() || '--'), vals: svLeaders.map(l => Number(l.value) || 0) },
    };
  }, [leaderboards]);

  const makeOption = (data, color, name) => ({
    backgroundColor: 'transparent',
    grid: { top: 20, right: 16, bottom: 60, left: 44 },
    tooltip: { trigger: 'axis', backgroundColor: '#1e3a29', borderColor: '#658d71', textStyle: { color: '#d8ceb3', fontSize: 10 } },
    xAxis: { type: 'category', data: data.names, axisLabel: { color: '#a9c9b1', fontSize: 8, rotate: 30 }, axisLine: { lineStyle: { color: '#658d71' } } },
    yAxis: { type: 'value', axisLabel: { color: '#a9c9b1', fontSize: 9 }, axisLine: { lineStyle: { color: '#658d71' } }, splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } } },
    series: [{ name, type: 'bar', data: data.vals, itemStyle: { color: color + 'CC', borderColor: color, borderWidth: 1 } }],
  });

  if (!eraData.names.length) return (
    <div className="text-[#658d71] text-xs text-center py-8 uppercase tracking-widest">No pitching data available</div>
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
      {[
        { data: eraData, color: '#a9c9b1', name: 'ERA', label: 'ERA' },
        { data: kData, color: '#c4333e', name: 'Strikeouts', label: 'Strikeouts' },
        { data: svData, color: '#d8ceb3', name: 'Saves', label: 'Saves' },
      ].map(({ data, color, name, label }) => (
        <div key={name} className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
          <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
            <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">{label}</span>
          </div>
          <div className="p-2">
            <ReactECharts option={makeOption(data, color, name)} style={{ height: '160px' }} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamPitchingChart;